<template>
    <div class="header modulewrap">
        <div class="langbarwrap">
            <div class="langbar realwrap"><a href="#" @click="setlangcur(1)" :class="{cs:$store.state.langcur == 1}">中文</a><span>|</span><a href="#" @click="setlangcur(2)" :class="{cs:$store.state.langcur != 1}">EN</a></div>
        </div>
        <div class="topbarwrap">
            <div :class="['topbarbox',isscroll?'topfixed':'']">
                <div class="topbar realwrap">
                    <div class="logo"><router-link to="/"><img :src="logo" /></router-link></div>
                    <div class="nav">
                        <ul>
                            <li v-for="item in navlist" :key="item.id" @mouseover="item.showmore=true" @click="item.showmore=true" @mouseout="item.showmore=false">
                                <template v-if="item.iscollege==1">
                                    <template v-if="collegeid>0 && topnavsort == item.kv">
                                        <router-link :class="['mainnav',{cs:topnavsort == item.kv}]" :to="item.url+'/'+collegecur.alias">{{$common.langinfo(collegecur.title,collegecur.title_en)}}</router-link>
                                        <transition name="fade">
                                            <div class="navmore" v-show="item.showmore">
                                                <dl>
                                                    <dd v-for="item2 in collegelist" :key="item2.id" v-if="item2.id!=collegeid"><router-link :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </template>
                                    <template v-else>
                                        <a :class="['mainnav',{cs:(topnavsort == item.kv ||item.showmore)}]" href="#">{{$common.langinfo(item.title,item.title_en)}}</a>
                                        <transition name="fade">
                                            <div class="navmore" v-show="item.showmore">
                                                <dl>
                                                    <dd v-for="item2 in collegelist" :key="item2.id"><router-link :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </template>
                                </template>
                                <template v-else>
                                    <router-link :class="['mainnav',{cs:topnavsort == item.kv}]" :to="item.url">{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                </template>
                            </li>
                            <li v-if="islogin" @mouseover="showme=true" @click="showme=true" @mouseout="showme=false">
                                <router-link to="/member" class="mainnav">Hi,<span class="showname">{{$store.state.showname}}</span></router-link>
                                <transition name="fade">
                                    <div class="dropdownbox" v-show="showme">
                                        <div class="dropdowntop">
                                            <dl class="ddinfo">
                                                <dt><router-link to="/member/profile"><img :src="$common.getface($store.state.face)" /></router-link></dt>
                                                <dd>
                                                    <router-link to="/member/profile">{{$store.state.showname}}</router-link>
                                                    <router-link to="/member/mobile" v-if="$store.state.showname!=me.mobile">{{$common.markmobile($store.state.mymobile)}}</router-link>
                                                </dd>
                                            </dl>
                                            <div class="ddexit">
                                                <a href="#" @click="$common.logout()">{{$common.dicword('logout')}}</a>
                                            </div>
                                        </div>
                                        <dl class="dropdownbottom">
                                            <dd v-for="item in mynav" v-if="item.isshortcut==1" :key="item.id"><router-link :to="item.url"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                                        </dl>
                                    </div>
                                </transition>

                            </li>
                            <li v-if="isloginload && !islogin"><router-link to="/home/login" class="mainnav">{{$common.dicword('login')}}</router-link><span>|</span><router-link to="/home/signup" class="mainnav">{{$common.dicword('reg')}}</router-link></li>
                        </ul>
                    </div>

                    <div class="navsmall" v-clickoutside="hidenav">
                        <div class="navmenu" @click="isshownav=!isshownav">
                            <i v-if="!islogin" class="iconfont icon-caidan"></i>
                            <img v-else :src="$common.getface($store.state.face)" />
                        </div>
                        <transition name="fade">
                            <div v-show="isshownav" class="navinfo">
                                <ul>
                                    <li v-for="(item,index) in navlist" :key="item.id" @click="shownavindex=index">
                                        <template v-if="item.iscollege==1">
                                            <a :class="{cs:topnavsort == item.kv}" href="#"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</a>
                                            <transition name="fade">
                                                <div class="navmore" v-show="shownavindex==index">
                                                    <dl>
                                                        <dd v-for="item2 in collegelist" :key="item2.id"><router-link @click.native="hidenav" :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                    </dl>
                                                </div>
                                            </transition>
                                        </template>
                                        <template v-else>
                                            <router-link :class="{cs:topnavsort == item.kv}" :to="item.url" @click.native="hidenav"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                        </template>
                                    </li>
                                    <li v-if="islogin" @click="shownavindex=99">
                                        <a href="#"><i class="iconfont icon-yonghu"></i>{{$common.dicword('membercenter')}}</a>
                                        <transition name="fade">
                                            <div class="navmore" v-show="shownavindex==99">
                                                <dl>
                                                    <dd class="mem" v-for="item in mynav" :key="item.id"><router-link :to="item.url" @click.native="hidenav"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                                                    <dd class="mem"><a href="/" @click.prevent="$common.logout()"><i class="iconfont icon-tuichudenglu"></i>{{$common.dicword('logout')}}</a></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </li>
                                    <li v-else class="navlogin"><router-link to="/home/login">{{$common.dicword('login')}}</router-link><span>|</span><router-link to="/home/signup">{{$common.dicword('reg')}}</router-link></li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cheader',
        data() {
            return {
                isshowcollege: false,

                logo: '',
                navlist: [],
                collegelist: [],
                me: {},
                mynav: [],
                isshownav: false,
                shownavindex: -1,
                islogin: false,
                isloginload: false,
                showme: false,
                isscroll: false//是否滚动，调整顶部导航
            };
        },
        props: {
            collegeid: {
                type: Number,
                default: 0
            }
        },
        computed: {
            collegecur: function () {
                return this.collegeid > 0 ? this.collegelist.find(item => item.id == this.collegeid) : {}
            },
            topnavsort: function () {
                return this.$store.state.topnavsort;
            }
        },
        methods: {
            setlangcur: function (v) {
                this.$store.commit('SET_LANGCUR', v);
                return false;
            },
            hidenav: function () {
                window.setTimeout(() => { this.shownavindex = -1; }, 50);

                this.isshownav = false;
            },
            logout: function () {
                this.hidenav();
                this.$common.logout();
            },
            headerscroll: function () {
                let scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isscroll = scrolltop > 110;
            }
        },
        mounted() {
            let jsondata = { 'postdata': { 'act': 'tea_header' }, 'msg': '' };
            this.$common.post(jsondata, res => {
                this.logo = res.infodatalogo.imgs;
                this.$store.dispatch('setlogourl', this.logo);//异步设置logo
                this.$store.dispatch('setislogin', res.islogin);
                this.islogin = res.islogin == 1;
                this.isloginload = true;
                this.$common.each(res.infodata, (item) => {
                    item.showmore = false;
                });
                this.navlist = res.infodata;
                this.collegelist = res.infodatacollege;
                if (this.islogin) {

                    this.$store.dispatch('setface', res.infodatame.face);

                    res.infodatame.showmore = false;
                    this.me = res.infodatame;

                    let showname = this.me.showname || this.me.username;
                    this.$store.dispatch('setshowname', showname);
                    this.$store.dispatch('setmobile', this.me.mobile);
                    this.$store.dispatch('setmemlev', res.infodatame.lev);

                    this.mynav = res.infodatamemnav;
                }

            });
            window.addEventListener('scroll', this.headerscroll, false)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.headerscroll, false);
        }
    };
</script>
